import { render, staticRenderFns } from "./lkuCoaExpenses.vue?vue&type=template&id=15353a08"
import script from "./lkuCoaExpenses.vue?vue&type=script&lang=js"
export * from "./lkuCoaExpenses.vue?vue&type=script&lang=js"
import style0 from "./lkuCoaExpenses.vue?vue&type=style&index=0&id=15353a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports